import css from "../../css/listing/request-form.module.css";
import formCss from "../../css/form/request.module.css";
import cssSpinner from "../../css/common/spinner.module.css";

import React from "react";
import PropTypes from "prop-types";
import Phone from "../form/Phone";
import { ErrorMessage, Field, withFormik } from "formik";
import * as Yup from "yup";
import { getFormErrors } from "../../service/formik-form";
import { postLead, LEAD_TYPE_LISTING } from "../../service/lead";

const ValidationSchema = Yup.object().shape({
    full_name: Yup.string().required("Required").label("Name").max(200),
    email: Yup.string()
        .email("Invalid email")
        .label("Email")
        .required("Required")
        .max(200),
    phone: Yup.string()
        .matches(/\([2-9]\d{2}\) \d{3}-\d{4}/, { message: "Incorrect phone" })
        .label("Phone")
        .required("Required"),
    message: Yup.string().required("Required").label("Message").max(5000),
});

class RequestForm extends React.PureComponent {
    componentDidUpdate() {
        window.dispatchEvent(new Event("resize"));
    }

    render() {
        const {
            values,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            status,
        } = this.props;

        const { phone } = values;

        if (status && status.success) {
            return (
                <div className={css.success}>
                    Thank you! We'll contact you shortly.
                </div>
            );
        }

        return (
            <>
                <div className={css.hiddenLabels}>
                    <label htmlFor="full_name">Name</label>
                    <label htmlFor="phone">Phone</label>
                    <label htmlFor="email">Email</label>
                    <label htmlFor="message">Message</label>
                </div>

                <div className={css.form}>
                    <form onSubmit={handleSubmit}>
                        <div className={formCss.group}>
                            <Field
                                type="text"
                                inputMode="text"
                                autoComplete="name"
                                id="full_name"
                                name="full_name"
                                placeholder="Name"
                                className={formCss.input}
                            />
                            <ErrorMessage
                                name="full_name"
                                component="div"
                                className={formCss.error}
                            />
                        </div>

                        <div className={formCss.group}>
                            <Phone
                                id="phone"
                                name="phone"
                                value={phone}
                                placeholder="Phone"
                                onChange={setFieldValue}
                                onBlur={setFieldTouched}
                                className={formCss.input}
                            />
                            <ErrorMessage
                                name="phone"
                                component="div"
                                className={formCss.error}
                            />
                        </div>

                        <div className={formCss.group}>
                            <Field
                                type="email"
                                inputMode="email"
                                autoComplete="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                className={formCss.input}
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className={formCss.error}
                            />
                        </div>

                        <div className={formCss.group}>
                            <Field
                                inputMode="text"
                                id="message"
                                component="textarea"
                                name="message"
                                rows={4}
                                className={formCss.textarea}
                            />
                            <ErrorMessage
                                name="message"
                                component="div"
                                className={formCss.error}
                            />
                        </div>

                        <button
                            type="submit"
                            className={
                                isSubmitting
                                    ? formCss.submitting
                                    : formCss.submit
                            }
                            disabled={isSubmitting}
                            onClick={handleSubmit}
                        >
                            {isSubmitting && (
                                <span
                                    className={cssSpinner.spinnerButton}
                                    style={{ marginRight: "5px" }}
                                />
                            )}
                            <span
                                style={{
                                    position: "relative",
                                    top: isSubmitting ? "-3px" : 0,
                                }}
                            >
                                Request Info
                            </span>
                        </button>
                    </form>
                    <div className={css.formText}>
                        By pressing request info, you agree that Residential and
                        real estate professionals may contact you via phone/text
                        about your inquiry, which may involve the use of
                        automated means.
                    </div>
                </div>
            </>
        );
    }
}

RequestForm.propTypes = {
    listing: PropTypes.object.isRequired,
};

const formikForm = withFormik({
    enableReinitialize: true,
    handleSubmit: async (
        values,
        { setSubmitting, props, setErrors, setStatus, resetForm }
    ) => {
        setSubmitting(true);

        const { listing } = props;

        try {
            await postLead(LEAD_TYPE_LISTING, {
                ...values,
                listing: listing.id,
            });

            resetForm();

            setStatus({
                success: true,
            });
        } catch (e) {
            setErrors(getFormErrors(e));
        }

        setSubmitting(false);
    },
    mapPropsToValues: (props) => {
        const { listing } = props;

        return {
            full_name: "",
            phone: "",
            email: "",
            message: `I am interested in ${listing.full_address}`,
        };
    },
    validationSchema: ValidationSchema,
})(RequestForm);

export default formikForm;
